import http from './http'
import Resource from './resource'

const path = 'admin/challenge'

class Challenge extends Resource {
  constructor(_http) {
    super(path, _http)
  }

  select(opt = {}) {
    return this.http.get(`api/${path}/select/list`, opt)
  }
}

const ChallengeRequest = new Challenge(http)

export default ChallengeRequest
